<template>
  <div class="cs-invoices" v-loading.fullscreen.lock="loading">
    <div v-if="isEmployeeAllowed">
      <div class="c-responsive-fixwidth card-wrapper">
        <div class="o-main-content-area">

          <div class="invoices-main">
            <div class="row">
              <div class="col-md-6">
                <div class="owner-part">
                  <div class="owner-logo">
                    <img src="static\assets\images\callstewardLogo.png" alt="logo" class="callsteward-logo" />                  
                  </div>
                  <div class="owner-address">
                    <div class="office-address">
                      <h2 class="h2">
                        CallSteward.Com
                      </h2>
                      <p class="street address">13 Winter Street</p>
                      <p class="city-state-zip">Dover-Foxcroft, Maine 04426</p>
                      <p class="country">United States</p>                    
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="statement-header">
                  <h1 class="h1">
                    Statement of Account
                  </h1>
                  <h3 class="h3">
                    Outstanding invoices
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div v-if="invoicesData.length">
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="client-address" v-if="invoicesData[0].customer">
                    <p class="bill-to">Bill To:</p>
                    <h3 class="h3"><strong>{{ invoicesData[0].customer&&invoicesData[0].customer.name?invoicesData[0].customer.name: '' }} </strong></h3>
                    <!-- <p class="admin-name">{{ invoicesData[0].customer.name }}</p> -->
                    <p class="street address">
                      <span v-if="invoicesData[0].customer.address.addressLine1&&invoicesData[0].customer.address.addressLine1!=''">{{ invoicesData[0].customer.address.addressLine1 }}</span>
                      <span v-if="invoicesData[0].customer.address.addressLine2&&invoicesData[0].customer.address.addressLine2!=''">{{ ', '+invoicesData[0].customer.address.addressLine2 }}</span>
                    </p>
                    <p class="city-province-zip">
                      <span class="city" v-if="invoicesData[0].customer.address&&invoicesData[0].customer.address.city">
                        {{ invoicesData[0].customer.address.city + " " }}
                      </span>
                      <span class="province" v-if="invoicesData[0].customer.address&&invoicesData[0].customer.address.province&&invoicesData[0].customer.address.province.name">
                        {{ invoicesData[0].customer.address.province.name }}
                      </span>
                      <span class="zip" v-if="invoicesData[0].customer.address&&invoicesData[0].customer.address.postalCode">{{ invoicesData[0].customer.address.postalCode }}</span>
                    </p>
                    <p class="country" v-if="invoicesData[0].customer.address&&invoicesData[0].customer.address.country&&invoicesData[0].customer.address.country.name">{{ invoicesData[0].customer.address.country.name }}</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="client-bill-overview">
                    <div class="client-bill-overview-header">
                      <h2 class="h2"><strong>{{ invoicesData.length&&invoicesData[0].currency.code == 'USD'? 'United States dollar (USD)' : invoicesData[0].currency.code }}</strong></h2>
                      <p class="date">{{ 'As of ' + momentTime(invoicesData[0].modifiedAt, '', 'MMM DD, YYYY' )  }}</p>
                    </div>
                    <div class="overview-bill-details">
                      <div class="bill-infomation">
                        <p class="">
                          <span class="key">Overdue</span>
                          <span class="value">${{ overdue_amount }}</span>
                        </p>
                        <p class="bill-infomation">
                          <span class="key">Not yet due</span>
                          <span class="value">${{ not_yet_due_amount ? not_yet_due_amount:'0.00' }}</span>
                        </p>
                        <p class="bill-total">
                          <span class="key">Outstanding balance (USD)</span>
                          <span class="value">${{ outstanding_amount }}</span>
                        </p>
                      </div>
                    </div>                
                  </div>
                </div>
                  
              </div>            
            </div>
            <div class="c-responsive-fixwidth mt-50">
                <div class="col-md-12 o-tab-area o-no-padding">
                    <ul class="o-tab-view o-tab-view--text">
                        <li href="javascript: void(0)" @click="changeToOutstanding()"><a class="call-deactive" :class="{ 'active': tab=='outstanding' }">Outstanding Invoices</a></li>
                        <li href="javascript: void(0)" @click="changeToAllInvoices()"><a class="call-deactive" :class="{ 'active': tab=='allInvoices' }">All Invoices</a></li>
                    </ul>
                </div>
            </div>
            <div class="invoice-table">
              <div>
                <el-table
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                    label="Invoice #"
                    width="180">
                      <template slot-scope="scope">
                        <!-- <span>Invoice {{ scope.row.invoiceNumber }}</span> -->
                        <a :href="scope.row.viewUrl" class="invoice-number" target="_blank">Invoice {{ scope.row.invoiceNumber }}</a>
                      </template>
                  </el-table-column>
                  <el-table-column
                    label="Invoice Date">
                      <template slot-scope="scope">
                        <span> 
                        {{ momentTime(scope.row.invoiceDate,'','MMM DD, YYYY') }}
                        </span>
                      </template>
                  </el-table-column>
                  <el-table-column
                    label="Due Date">
                      <template slot-scope="scope">
                        <span> 
                        {{ momentTime(scope.row.dueDate,'YYYY-MM-DD','MMM DD, YYYY') }}
                        </span> 
                        <span v-if="scope.row.status=='OVERDUE'" class="font-red"><br />Overdue</span>
                      </template>
                  </el-table-column>
                  <el-table-column
                    label="Total">
                      <template slot-scope="scope">
                        <span> 
                        ${{ scope.row.total.value }}
                        </span>
                      </template>
                  </el-table-column>
                  <el-table-column
                    label="Paid">
                      <template slot-scope="scope">
                        <span> 
                        ${{ scope.row.amountPaid.value }}
                        </span>
                      </template>
                  </el-table-column>
                  <el-table-column
                    label="Due">
                      <template slot-scope="scope">
                        <span> 
                        ${{ scope.row.amountDue.value }}
                        </span>
                      </template>
                  </el-table-column>
                  <!-- <el-table-column
                    prop="status"
                    label="Status">
                  </el-table-column> -->
                </el-table>
              </div>
              <div class="row" v-if="tab=='outstanding'">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <div class="final-total">
                    <p class="bill-total">
                      <span class="key">Outstanding balance (USD)</span>
                      <span class="value">${{ outstanding_amount }}</span>
                    </p>
                  </div>
                </div>
              </div>          
            </div>

          </div>
          <!-- <div v-else-if="errorMessage && errorMessage != ''">
            <p class="no-invoices">
              {{ errorMessage }}
            </p>
          </div> -->
          <div v-else>
            <p class="no-invoices" v-if="!loading">
              No Invoices Found
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <NotAllowed />
    </div>
  </div>
</template>

<script>

import service from '../services.js';
import { mapGetters } from 'vuex';
import NotAllowed from '@/components/NotAllowed';


export default {
  data() {
    return {
      isEmployeeAllowed: true,
      clientData: null,
      invoicesData: [],
      outstanding_amount: 0.00,
      not_yet_due: 0.00,
      overdue_amount: 0.00,
      not_yet_due_amount: 0.00,
      paid_invoices:[],
      not_paid_invoices: [],
      errorMessage: '',
      loading: false,
      tab: 'outstanding',
      tableData: []
    };
  },
   components: {
    'NotAllowed': NotAllowed
  },
  computed: {
    ...mapGetters({
        userToken: 'userToken',
        userRole: 'userRole',
        userRoleSlug: 'userRoleSlug',
        userClientID: 'userClientID',
        employeeId: 'employeeId',
        currentEmployeeID: 'currentEmployeeID',
        // getNotificationType: 'getNotificationType',
        userID: 'userID',
        getNylasUserEmail: 'getNylasUserEmail'
    })
  },
  methods: {
    changeToOutstanding() {
      this.tab = 'outstanding';
      this.tableData = this.not_paid_invoices;
      if(this.outstanding_amount == 0) {
        this.tableData = [];
      }
    },
    changeToAllInvoices() {
      this.tab = 'allInvoices';
      this.tableData = this.invoicesData;
    },    
    momentTime(date,currentFormat,reqFormat) {
      return moment(date,currentFormat).format(reqFormat);
    },
    async getInvoiceData() {
      this.loading = true;
      await service.get('client/'+this.userClientID+'/getClientAllInvoices', {
      'Authorization': this.userToken
      })
      .then((res) => {
          this.loading = false;
          // this.errorMessage = '';
          if(res.data.status_code == '0') {
            // this.errorMessage = res.data.status_message;
            this.$notify.error({
              title: 'Warning',
              message: res.data.status_message
            })
          }
          this.invoicesData = res.data.result;
          this.groupingInvoices();
          // this.getAllPaidInvoices();      
          // console.log(res.data);
      }).catch((err) => {
          this.loading = false;
          // console.log(err.response.data);
          if(err.response&&err.response.status&&err.response.status==403) {
              this.isEmployeeAllowed = false;
              this.$notify({
                  title: 'Important message',
                  message: "You don't have Access!",
                  type: 'error'
              });
              this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
          }
          if(err.response&&err.response.data&&err.response.data.status_message&&err.response.status!=403) {
            this.errorMessage = err.response.data.status_message;
          }
      });
    },
    // calculateOutstanding() {
      // let sum = 0.00;
      // this.invoicesData.forEach(item => {
      //   console.log(item.amountDue.value);
      //   let val = Math.round(item.amountDue.value * 100) / 100;
      //   sum = sum + val
      // })
      // this.outstanding_amount = this.overdue_amount + this.not_yet_due_amount;
    // },
    calculateAmounts() {
      let outstandingAmount = 0.00;
      let notYetDueAmount = 0.00;
      this.invoicesData.forEach(item => {
        console.log(item.amountDue.value);
        if(item.status == 'OVERDUE') {
          let val = Math.round(item.amountDue.value.replace(/,/g, '') * 100) / 100;
          outstandingAmount = outstandingAmount + val;
        }
        if(item.status != 'OVERDUE' && item.status != 'PAID') {
          let val = Math.round(item.amountDue.value.replace(/,/g, '') * 100) / 100;
          notYetDueAmount = notYetDueAmount + val;
        }
      })
      this.overdue_amount = outstandingAmount;
      this.not_yet_due_amount = notYetDueAmount;
      this.outstanding_amount = outstandingAmount + notYetDueAmount;
    },
    // calculateNotYetDue() {
    //   let sum = 0.00;
    //   this.invoicesData.forEach(item => {
    //     if(item.status != 'OVERDUE' && item.status != 'PAID') {
    //       let val = Math.round(item.amountDue.value * 100) / 100;
    //       sum = sum + val;
    //       sum = Math.round(sum * 100) / 100;
    //     }
    //   })
    //   this.not_yet_due_amount = sum;
    // },
    groupingInvoices() {
      let notPaidInvoices = [];
      // let paidInvoices = [];
      
      this.invoicesData.forEach(item => {
        let amountDue = Math.round(item.amountDue.value * 100) / 100;
        if(amountDue != 0) {
          notPaidInvoices.push(item)
        }
        // if(amountDue == 0) {
        //   paidInvoices.push(item)
        // }
      })
      this.not_paid_invoices = notPaidInvoices; 
      // this.paid_invoices = paidInvoices;      
    },
    // getAllPaidInvoices() {
    //   let paidInvoices = [];
    //   this.invoicesData.forEach(item => {
    //     if(item.status == 'PAID') {
    //       paidInvoices.push(item)
    //     }
    //   })
    //   this.paid_invoices = paidInvoices;      
    // },
    async getClientData() {
      await service.get('client/' + this.userClientID, {
      'Authorization': this.userToken
      })
      .then((res) => {
          this.clientData = res.data.result;
      }).catch((err) => {
          console.log(err);
      });
    },
  },
  async created() {
    // await this.getClientData();
    await this.getInvoiceData();
    this.calculateAmounts();
    this.changeToOutstanding();
    // this.calculateNotYetDue();
    // this.calculateOutstanding();
  },
  mounted() {}
}
</script>

<style scoped>

.mt-50 {
  margin-top: 50px;
}

.no-invoices {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
  text-align:center;
  padding: 40px 0;
}
.invoice-number {
  color: #3400c4;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.font-red {
  color: #c50505;
}

.card-wrapper {
  width: 900px;
  margin: 80px auto;
  border-top: solid 5px #FFA10A;
  box-shadow: 0 2px 2px 2px #bebebe;
  background-color: #fcfcfc;
}
.invoices-main{
  padding: 0 30px 0 30px;
}
.owner-part {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 80px;
}

.client-bill-overview {
  text-align: right;
}

.client-bill-overview-header {
  border-bottom: 1px solid #ECF0F3;
  padding: 10px;
}

.client-address p {
  line-height: 1.5;
}

.overview-bill-details {
  padding-top: 10px;
}

.bill-infomation p {
  line-height: 1.5;
  padding:5px 10px;
}

.bill-infomation p .key {
  padding-right: 30px;
}
.bill-infomation p .value {
  padding-left: 30px;
}

.bill-total {
  margin-top: 20px;
  padding: 10px;
  background-color: #ECF0F3;
  font-weight: 500;
}
.owner-logo {
  margin-right: 10px;
}
.callsteward-logo {
  width:180px;
  /* border: 1px solid #000000; */
}
.statement-header{
  padding-top: 20px;
  text-align: right;
}
.statement-header h1 {
  font-size: 1.5em;
  font-weight: 500;
}
.office-address h2 {
  font-size: 18px;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 5px;
}
.owner-address p {
  line-height: 1.3;
}
.invoice-table {
  padding: 60px 10px;
}

.final-total {
  text-align: right;
  margin: 10px;
}

.final-total .bill-total .key {
  padding-right: 30px;
}
.final-total .bill-total .value {
  padding-left: 30px;
}

</style>
